module.exports = __webpack_public_path__ + "img/operation-guideline.9f7df824.png";